<template>
    <div class="method-icon">
        <img v-if="currency === 'USD'" src="@/assets/img/wallets/method_icon/cashapp.png" />
        <img v-if="currency === 'TRY'" src="@/assets/img/wallets/method_icon/papara.png" />
        <img v-if="currency === 'BRL'" src="@/assets/img/wallets/method_icon/pix.png" />
        <img v-if="currency === 'NGN'" src="@/assets/img/wallets/method_icon/palmpay.png" />
        <img v-else src="@/assets/img/wallets/method_icon/gcash.png" />
    </div>
</template>
<script setup lang="ts">
import { useBaseStore } from '@/stores'

const store = useBaseStore()

const currency = computed(() => store.wallet?.currency)
</script>
<style lang="scss" scoped>
.method-icon {
    position: relative;
    margin: 0 auto;
    width: 264px;
    height: 88px;
    border-radius: 40px;
    overflow: hidden;

    img {
        max-width: inherit !important;
        width: 324px;
        height: 88px;
    }
}
</style>
